import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import { Logo, NamedRedirect } from '../../components';
import { getCurrentLocale } from '../../util/locale';
import { useConfiguration } from '../../context/configurationContext';
import { isMarketplaceSecondLife } from '../../util/marketplace';

import css from './LandingPage.module.css';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const SearchPage = loadable(() =>
  import(/* webpackChunkName: "SearchPage" */ '../SearchPage/SearchPage')
);

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error, isAuthenticated } = props;

  const config = useConfiguration();
  const isSecondLife = isMarketplaceSecondLife(config);

  // If user is authenticated and this is 2ndLife → redirect to My Listings
  if (isSecondLife && isAuthenticated) {
    return <NamedRedirect name="SearchPageMyListings" />;
  }

  // Otherwise show landing → which for 2ndLife guest already behaves like SearchPage
  const urlLocale = getCurrentLocale();

  if (urlLocale) {
    return <SearchPage />;
  }

  return (
    <PageBuilder
      className={css.root}
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
      hideFooter
      topbar={<Logo className={css.logo} />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { isAuthenticated } = state.auth;

  return { pageAssetsData, inProgress, error, isAuthenticated };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
